import React, { useRef } from 'react';
import { connect } from 'react-redux';

import { changeFormFieldValue } from 'apps/auth/actions/formAction';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import FreePaymentSource from 'apps/auth/components/paysendPlus/subscription/FreePaymentSource';
import PaysendPlusEmployeePrecheckPopup from 'apps/auth/components/paysendPlus/subscription/PaysendPlusEmployeePrecheckPopup';
import { ONE_MONTH_SUBSCRIPTION } from 'apps/auth/components/paysendPlus/utils';
import BasePage from 'apps/auth/components/utils/BasePage';
import { PLUS_SUBSCRIBE_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_PLUS_MAIN_PAGE, AUTH_PLUS_SUBSCRIBE_ACTION } from 'apps/auth/constants/UrlConstants';
import { useExtra, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const PaysendPlusEmployeeSubscribePage = (props) => {
    const popupRef = useRef(null);
    const submitRef = useRef(null);
    const { subscriptionTariffs, otherSourceShow, otherSource, subscriptionCurrencyCode } = useExtra();
    const { paymentMethodsTitle, otherSourceTitle } = usePageMessages();
    const { fields } = useForm(PLUS_SUBSCRIBE_FORM_NAME);

    const getSelectedTariff = () => {
        return subscriptionTariffs.find((t) => t.id === fields?.planId?.value);
    };

    const openPrecheck = (card = null, paymentMethod) => {
        props.changeFormFieldValue(PLUS_SUBSCRIBE_FORM_NAME, ONE_MONTH_SUBSCRIPTION, 'planId');
        props.changeFormFieldValue(PLUS_SUBSCRIBE_FORM_NAME, paymentMethod, 'pMethodId');
        props.changeFormFieldValue(PLUS_SUBSCRIBE_FORM_NAME, '', 'pMethodEncodedInfo').then(() => {
            popupRef?.current.open(
                <PaysendPlusEmployeePrecheckPopup
                    popupRef={popupRef}
                    actionType={'subscription'}
                    action={AUTH_PLUS_SUBSCRIBE_ACTION}
                    subscriptionCurrencyCode={subscriptionCurrencyCode}
                    tariff={getSelectedTariff()}
                    submitRef={submitRef}
                    selectedCard={card}
                />,
            );
        });
    };

    return (
        <>
            <CommonPage backUrl={AUTH_PLUS_MAIN_PAGE} leftCloseIcon>
                {otherSourceShow && (
                    <>
                        <HeaderPanel title={paymentMethodsTitle} />
                        <Text variant="div" size="subheader" color="secondary" indent="adaptive-16-24">
                            {otherSourceTitle}
                        </Text>
                        <FreePaymentSource name={otherSource.name} icon="paysend-logo-globe-circle" popupRef={popupRef} openClick={openPrecheck} />
                    </>
                )}
            </CommonPage>
            <PopupNew ref={popupRef} />
        </>
    );
};

export default connect(null, { changeFormFieldValue })(BasePage(PaysendPlusEmployeeSubscribePage));
